<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Comparativo de Ventas</strong>
            <p class="header-description">Cuadro comparativo entre el período seleccionado y el mismo período del año anterior</p>
          </div>
          <b-form>
            <b-form-group
              label="Desde"
              label-for="periodoDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoDesdeMesNombre" 
                :options="meses" 
                class="mb-3 select-fecha select-fecha-mes">
                <template slot="first">
                  <option :value="null">Seleccione un mes</option>
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoDesdeAnio" 
                :options="anios" 
                class="mb-3 select-fecha select-fecha-anio">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="Hasta"
              label-for="periodoHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-select 
                v-model="periodoHastaMesNombre" 
                :options="meses" 
                class="mb-3 select-fecha select-fecha-mes">
                <template slot="first">
                  <option :value="null">Seleccione un mes</option>
                </template>
              </b-form-select>
              <b-form-select 
                v-model="periodoHastaAnio" 
                :options="anios" 
                class="mb-3 select-fecha select-fecha-anio">
                <template slot="first">
                  <option :value="0">Seleccione un año</option>
                </template>
              </b-form-select>
            </b-form-group>

            <b-form-group
              :label-cols="labelCols"
              horizontal>
              <b-form-checkbox 
                  id="sinReembolsos"
                  v-model="sinReembolsos"
                  :value="true"
                  :unchecked-value="false">
                  Consultar Ventas sin Reembolsos
              </b-form-checkbox>
            </b-form-group>
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import moment from 'moment';

export default {
  name: 'VentasRptComparativo',
  components: {
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      periodoDesdeMesNombre: null,
      periodoDesdeAnio: 0,
      periodoHastaMesNombre: null,
      periodoHastaAnio: 0,
      sinReembolsos: false,

      labelCols: 1,
      meses: [],
      anios: []
    }
  },
  created() {
    this.meses = this.getMeses();
    this.anios = this.getAniosPeriodo();

    let fecha = moment.utc(new Date()).format('YYYY-MM-DD')

    this.periodoDesdeMes= new Date(fecha).getMonth() + 1;
    this.periodoDesdeMesNombre= this.getMesNombre(this.periodoDesdeMes);
    this.periodoDesdeAnio= new Date(fecha).getFullYear();

    this.periodoHastaMes= new Date(fecha).getMonth() + 1;
    this.periodoHastaMesNombre= this.getMesNombre(this.periodoHastaMes);
    this.periodoHastaAnio= new Date(fecha).getFullYear();
  },
  methods: {
    validate() {
    },
    exportXls () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let fechaDesde = parseInt(this.periodoDesdeAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.periodoDesdeMesNombre).trim()
          + '-01';

      let fechaHasta = parseInt(this.periodoHastaAnio).toString().trim()
          + '-' + this.getMesNumeroToString(this.periodoHastaMesNombre).trim()
          + '-01';

      let params = {
        fechaDesde,
        fechaHasta,
        sinReembolsos: this.sinReembolsos
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('ventas/getRptVentasComparativo', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptVentas = this.$store.getters['ventas/rptVentas'];

            if (rptVentas) {
              if (rptVentas.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Comparativo';
              let fileName = 'ventas-comparativo';
              let format = [
                { titulo: 'Período', nombre: 'periodo', formato: 'periodo' },
                { titulo: 'Monto Anterior', nombre: 'montoPeriodoAnterior', formato: '' },
                { titulo: 'Monto Anterior Ajustado', nombre: 'montoPeriodoAnteriorAjustado', formato: '' },
                { titulo: 'Monto Actual', nombre: 'montoPeriodo', formato: '' },
                { titulo: 'Pje Variación', nombre: 'pjeAumento', formato: '' },
                { titulo: 'Pje Inflacion Acumulada', nombre: 'pjeInflacionAcumulada', formato: '' }
              ];

              this.exportXLS(title, fileName, rptVentas, format);              
              
            } else {
              this.showModalMsj('No hay datos para exportar.', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
  },
}
</script>

<style>
  p.header-description {
    font-size: 12px;
    font-style: italic;
  }
</style>
